import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { GetRailProps } from "react-compound-slider";

// *******************************************************
// RAIL
// *******************************************************
const railOuterStyle: React.CSSProperties = {
  position: "absolute",
  width: "100%",
  height: 42,
  transform: "translate(0%, -50%)",
  borderRadius: 9,
  cursor: "pointer",
  // border: '1px solid white',
};

const railInnerStyle: React.CSSProperties = {
  position: "absolute",
  width: "100%",
  height: 10,
  transform: "translate(0%, -50%)",
  borderRadius: 9,
  pointerEvents: "none",
  backgroundColor: "#BDBDBD",
  border: "1px solid #8C8C8C",
};

type Props = {
  getRailProps: GetRailProps;
};

export default function MtiSliderRail({ getRailProps }: Props) {
  return (
    <Fragment>
      <div style={railOuterStyle} {...getRailProps()} />
      <div style={railInnerStyle} />
    </Fragment>
  );
}

MtiSliderRail.propTypes = {
  getRailProps: PropTypes.func.isRequired,
};
